<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div
      class="left-side-switch"
      onclick="sideChangeStatus();"
    >
      <i
        class="fa"
        :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"
      ></i>
    </div>-->
    <div>
      <h6
        class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
      >
        {{ $t("order.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('order.SKU编号')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="keySku"
          />
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary search btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium"
      @click="filtrate"
    >
      {{ $t("order.筛 选") }}
    </button>
    <!-- todo3-销量报表 -->
    <button
      @click="batchSearch('skuReport')"
      class="
        btn btn-primary batchSearch btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
    >
      {{ $t("distributor.批量搜索") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "key_sku"],
  data() {
    return {
      keySku: "",
    };
  },
  watch: {
    key_sku: function () {
      this.keySku = this.key_sku;
    },
  },
  methods: {
    batchSearch(key){
      this.$emit('batchSearch', key)
    },
    filtrate() {
      this.$emit("filtrate", this.keySku);
    },
  },
};
</script>

